import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import {Config} from '../config.service';

@Injectable()
export class PlatformContextService {

  constructor(public readonly config: Config) {}

  getPlatformContext() {
    return this.config.getConfig('app');
  }

  isSalarie() {
    return this.config.getConfig('app') === 'salarie';
  }

  isElu() {
    return this.config.getConfig('app') === 'elu';
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/context/platform-context.service.ts